
import {debounceTime} from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteModel } from '../../../models/site.model';
import { ClientModel } from '../../../models/client.model';
import { ConsumerService } from '../../../services/consumer.service';
import { Subscription, Subject } from 'rxjs';
import { MultiDeviceInteractionState, MultiDeviceInteractionModel, InteractionWhoModel } from '../../../models/consumer/consumer-interaction.model';
import { MultiDeviceInteractionService } from '../../../services/multi-device-interaction.service';
import { ConsumerModel } from '../../../models/consumer/consumer.model';

@Component({
    selector: 'multi-device-who',
    templateUrl: './multi-device-who.component.html',
    styles: []
})
export class MultiDeviceWhoComponent implements OnInit, OnDestroy {

    constructor(
        private fb: UntypedFormBuilder,
        private consumerService: ConsumerService,
        private multiDeviceInteractionService: MultiDeviceInteractionService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    allSites: SiteModel[];
    private searchUpdate: Subject<string> = new Subject<string>();
    private selectedSearchUpdate: Subject<string> = new Subject<string>();
    private siteUpdate: Subject<number> = new Subject<number>();
    searchSubscription: Subscription = new Subscription();
    subscriptions: any[] = [];

    allClients: ClientModel[];
    filteredClients: ClientModel[] = [];
    selectedClients: ClientModel[] = [];

    filter: any[] = [];
    isLoading: boolean = true;

    consumerFilteredSearchResults: ConsumerModel[] = [];
    consumerFilteredSelectedResults: ConsumerModel[] = [];

    allConsumerResults: ConsumerModel[] = [];
    get consumerUnSelectedResults() {

        if (this.selectedSite == 0 && !this.searchTerm) {
            return this.allConsumerResults.filter(x => !x.selected);

        } else if (this.selectedSite == 0 && this.searchTerm) {

            return this.allConsumerResults.filter(x => !x.selected)
                .filter(x => x.consumerAddress.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()));

        } else if (this.selectedSite > 0 && !this.searchTerm) {
            return this.allConsumerResults.filter(x => !x.selected).filter(x => x.siteId == this.selectedSite);
        }

        return this.allConsumerResults.filter(x => !x.selected && x.siteId == this.selectedSite && x.consumerAddress.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()));
    }

    get consumerSelectedResults() {

        if (this.selectedSite == 0 && !this.selectedSearchTerm) {
            return this.allConsumerResults.filter(x => x.selected);

        } else if (this.selectedSite == 0 && this.selectedSearchTerm) {

            return this.allConsumerResults.filter(x => x.selected)
                .filter(x => x.consumerAddress.toLocaleLowerCase().includes(this.selectedSearchTerm.toLocaleLowerCase()));

        } else if (this.selectedSite > 0 && !this.selectedSearchTerm) {
            return this.allConsumerResults.filter(x => x.selected).filter(x => x.siteId == this.selectedSite);
        }

        return this.allConsumerResults.filter(x => x.selected && x.siteId == this.selectedSite && x.consumerAddress.toLocaleLowerCase().includes(this.selectedSearchTerm.toLocaleLowerCase()));
    }

    selectedSite: number = 0;
    searchTerm: string;
    selectedSearchTerm: string;
    clientId: number;
    totalItems: number = 0;
    submitted: boolean = false;

    form: UntypedFormGroup;
    interactonData: MultiDeviceInteractionModel;

    ngOnInit() {
        this.allSites = this.route.snapshot.data.sites;
        this.allClients = this.route.snapshot.data.clients;
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.filter.push("payg");

        let selectedSite = 0;
        let howModel = this.multiDeviceInteractionService.howModel;
        if (howModel && howModel.siteId) {
            selectedSite = howModel.siteId;
        }

        this.form = this.fb.group({
            search: [null, null],
            selectedSearch: [null, null],
            site: [selectedSite, null]
        });

        this.searchSubscription.unsubscribe();
        this.consumerService.getAll(this.clientId, "PAYG").then((res) => {
            // return all consumers
            let result = res as ConsumerModel[];
            result = result.map((results) => {
                results.selected = false;
                return results;
            });

            this.allConsumerResults = result;
            this.consumerFilteredSearchResults = result;
            this.populateFromStorage();
            this.totalItems = result.length;
            this.isLoading = false;
            this.sort();
        });

        const eventStream = this.searchUpdate.asObservable().pipe(
            debounceTime(300)).pipe(distinctUntilChanged());

        const selectedEventStream = this.selectedSearchUpdate.asObservable().pipe(
            debounceTime(300)).pipe(distinctUntilChanged());

        const eventSiteStream = this.siteUpdate.asObservable()
            .pipe(distinctUntilChanged());

        this.subscriptions.push(eventStream.subscribe(input => this.consumerUnSelectedResults));

        this.subscriptions.push(selectedEventStream.subscribe(input => this.consumerSelectedResults));

        this.subscriptions.push(this.form.controls['search'].valueChanges.subscribe(searchResult => {
            this.searchUpdated(searchResult);
        }));

        this.subscriptions.push(this.form.controls['selectedSearch'].valueChanges.subscribe(selectedSearchResult => {
            this.selectedSearchUpdated(selectedSearchResult);
        }));

        this.subscriptions.push(this.form.controls['site'].valueChanges.subscribe(siteResult => {
            this.selectedSite = siteResult;
            this.siteUpdated(siteResult);
        }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    searchUpdated(value: string) {
        this.searchTerm = value;
        this.searchUpdate.next(value);
    }

    selectedSearchUpdated(value: string) {
        this.selectedSearchTerm = value;
        this.selectedSearchUpdate.next(value);
    }

    siteUpdated(value: number) {
        this.selectedSite = value;
        this.siteUpdate.next(value);
    }

    selectAll() {

        //if any search terms or site id selected select what the user sees 
        if (this.selectedSite == 0 && !this.searchTerm) {
            this.allConsumerResults.forEach(x => x.selected = true);
        }
        else if (this.selectedSite == 0 && this.searchTerm) {
            this.allConsumerResults.filter(x => x.consumerAddress.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())).forEach(x => x.selected = true);
        } else if (this.selectedSite > 0 && !this.searchTerm) {
            this.allConsumerResults.filter(x => x.siteId == this.selectedSite).forEach(x => x.selected = true);
        } else if (this.selectedSite > 0 && this.searchTerm) {
            this.allConsumerResults.filter(x => x.siteId == this.selectedSite && x.consumerAddress.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())).forEach(x => x.selected = true);
        }

        this.sort();
    }

    removeAll() {
        this.allConsumerResults.forEach(x => x.selected = false);
        this.sort();
    }

    addConsumer(item: any, index: number) {
        let found = this.allConsumerResults.find(x => x.consumerId === item.consumerId);
        found.selected = true;
    }

    removeConsumer(item: any, index: number) {
        let found = this.allConsumerResults.find(x => x.consumerId === item.consumerId);
        found.selected = false;
    }

    sort() {
        this.allConsumerResults.sort((a, b) => (a.propertyReference > b.propertyReference) ? 1 : ((b.propertyReference > a.propertyReference) ? -1 : 0));
        this.consumerSelectedResults.sort((a, b) => (a.propertyReference > b.propertyReference) ? 1 : ((b.propertyReference > a.propertyReference) ? -1 : 0));
        this.consumerFilteredSearchResults.sort((a, b) => (a.propertyReference > b.propertyReference) ? 1 : ((b.propertyReference > a.propertyReference) ? -1 : 0));
    }

    populateFromStorage() {
        if (this.multiDeviceInteractionService.whoModel) {

            let sessionWhoModel = this.multiDeviceInteractionService.whoModel;

            for (let i = 0; i < this.allConsumerResults.length; i++) {
                for (let k = 0; k < sessionWhoModel.consumerIds.length; k++) {
                    if (this.allConsumerResults[i].consumerId == sessionWhoModel.consumerIds[k]) {
                        this.allConsumerResults[i].selected = true;
                    }
                }
            }
        }
    }

    submit(form: UntypedFormGroup) {
        this.submitted = true;
        if (!form.valid) return;
        if (this.consumerSelectedResults.length == 0) return;

        this.interactonData = JSON.parse(window.sessionStorage.getItem("multi-device-interaction")) as MultiDeviceInteractionModel;
        this.interactonData.who = new InteractionWhoModel();

        for (let i = 0; i < this.consumerSelectedResults.length; i++) {

            this.interactonData.who.consumerIds.push(this.consumerSelectedResults[i].consumerId);

            if (!this.interactonData.who.clientIds.find(x => x == this.consumerSelectedResults[i].clientId)) {
                this.interactonData.who.clientIds.push(this.consumerSelectedResults[i].clientId);
            }

            if (!this.interactonData.who.siteIds.find(x => x == this.consumerSelectedResults[i].siteId)) {
                this.interactonData.who.siteIds.push(this.consumerSelectedResults[i].siteId);
            }
        }

        this.multiDeviceInteractionService.whoModel = this.interactonData.who;

        let currentState = MultiDeviceInteractionState.who;
        let nextState = this.multiDeviceInteractionService.getNextState(currentState);

        this.router.navigated = false;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { state: nextState }
        });
    }
}
